const types = Object.freeze({
    auth: {
        default: "Se consulta endpoint de servicio auth [default]",
        success: "Se consulta endpoint de servicio auth [success]",
        fail: "Se consulta endpoint de servicio auth [fail]",
      },
      USER_TOKEN: "[User] User Token",
});
export default types;
